import { gql } from '@apollo/client'
import { GROUP_NUMBER_RELATION_QUERY, HAS_PRIVILEGE_QUERY, MDL_DOCKET_VERIFIED_QUERY } from '../graphql'
import { ACTION_TYPE, BEHAVIOR_TYPE } from '../constants'
import { PRIVILEGE } from '../components/CustomCode/BosSci/bossci_constants'
import { FIELD_ID } from '../components/CustomCode/BosSci/bossci_constants'
import { makeInteger } from '../utils'
import CaseSelection from '../components/CustomCode/BosSci/CaseSelection'

const matrixTypeJuly2021 = 31544249
const  GROUP_NUMBER_RELATION = gql(GROUP_NUMBER_RELATION_QUERY)
const HAS_PRIVILEGE = gql(HAS_PRIVILEGE_QUERY)
const MDL_DOCKET_VERIFIED = gql(MDL_DOCKET_VERIFIED_QUERY)

const bossci = {
  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
  //console.log('bossci.validation_hook', fieldInput, objectId, formInputs)

    let validationMessage = ''
  
    switch (makeInteger(fieldInput.field.id)) {

      case FIELD_ID.bostonMatter.groupNumber:
        if (fieldInput.currentValue.id) {
          if (formInputs[FIELD_ID.bostonMatter.settlementGroup].currentValue.id) {
            try {
              const results = await window.apolloClient.query({ query: GROUP_NUMBER_RELATION, variables: { groupId: fieldInput.currentValue.id, settlementId: formInputs[FIELD_ID.bostonMatter.settlementGroup].currentValue.id } })
              if (results.data) {
                if (results.data.groupNumberRelation === 0) {
                  validationMessage = `That "${formInputs[FIELD_ID.bostonMatter.settlementGroup].field.name}" / "${fieldInput.field.name}" combination does not exist in "Settlement Group / Group Number" priority table.`
                }
              }
            } catch (err) {
              console.log(JSON.stringify(err))
            }
          } else {
            validationMessage = `The "${fieldInput.field.name}" selection must be accompanied by a valid "${formInputs[FIELD_ID.bostonMatter.settlementGroup].field.name}" selection.`
          }
        }
        break
      case FIELD_ID.bostonMatter.caseStatus:
        if (fieldInput.currentValue) {
          if (makeInteger(fieldInput.currentValue.id) === FIELD_ID.bostonMatter.claimStatusPending) {
            if (formInputs[FIELD_ID.bostonMatter.dob].currentValue === '' && formInputs[FIELD_ID.bostonMatter.ssn].currentValue === '') {
              validationMessage = `${formInputs[FIELD_ID.bostonMatter.dob].field.name} or ${formInputs[FIELD_ID.bostonMatter.ssn].field.name} must be specified before status of "Pending" is allowed.`
            }
          }
        }
        break
      case FIELD_ID.bostonMatter.settlementFundReleaseDate:
        if (fieldInput.currentValue) {
          if (formInputs[FIELD_ID.bostonMatter.ssn].currentValue === '') {
            validationMessage = `Plaintiff "${formInputs[FIELD_ID.bostonMatter.ssn].field.name}" cannot be blank in order to specify a "${fieldInput.field.name}."`
          }
          if (makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusPending && makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusInactive) {
            validationMessage = `"${formInputs[FIELD_ID.bostonMatter.caseStatus].field.name}" must be set to "Pending" or "Inactive" in order to specify a "${fieldInput.field.name}."`
          }
          if (!formInputs[FIELD_ID.bostonMatter.releaseFile].currentValue) {
            validationMessage = `A "${formInputs[FIELD_ID.bostonMatter.releaseFile].field.name}" must be attached in order to specify a "${fieldInput.field.name}."`
          } 
        } 
        break
      case FIELD_ID.bostonMatter.settlementStatus:
        if (fieldInput.currentValue.id) {
          if (makeInteger(fieldInput.currentValue.id) === FIELD_ID.bostonMatter.settleStatusOfferPending) {
            if (makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusPending 
            && makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusInactive) {
              validationMessage = `"${formInputs[FIELD_ID.bostonMatter.caseStatus].field.name}" must be set to "Pending" or "Inactive" in order to specify a settlement status of "Offer Pending."`
            }
          }
        }
        if (makeInteger(fieldInput.currentValue.id) === FIELD_ID.bostonMatter.settleStatusFundsReleased) {
          if (!formInputs[FIELD_ID.bostonMatter.ssn].currentValue) {
            validationMessage = `Plaintiff ${formInputs[FIELD_ID.bostonMatter.ssn].field.name} cannot be blank in order to specify a settlement status of "Funds Released."`
          }
          if (makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusPending && makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusInactive) {
            validationMessage = `"${formInputs[FIELD_ID.bostonMatter.caseStatus].field.name}" must be set to "Pending" or "Inactive" in order to specify a settlement status of "Funds Released."`
          }
          if (!formInputs[FIELD_ID.bostonMatter.releaseFile].currentValue) {
            validationMessage = `A "${formInputs[FIELD_ID.bostonMatter.releaseFile].field.name}" must be attached in order to specify a settlement status of "Funds Released."`
          }
        }
        break
      case FIELD_ID.bostonMatter.settlementAmount: 
        if (fieldInput.currentValue) {
          if (makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusPending && makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusInactive) {
            validationMessage = `"${formInputs[FIELD_ID.bostonMatter.caseStatus].field.name}" must be set to "Pending" or "Inactive" in order to specify a settlement amount.`
          }
        }
        break
      case FIELD_ID.bostonMatter.releaseFile:
        if (fieldInput.currentValue) {
          if (makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusPending && makeInteger(formInputs[FIELD_ID.bostonMatter.caseStatus].currentValue.id) !== FIELD_ID.bostonMatter.claimStatusInactive) {
            validationMessage = `"${formInputs[FIELD_ID.bostonMatter.caseStatus].field.name}" must be set to "Pending" or "Inactive" in order to attach a "${fieldInput.field.name}."`
          }
          if (formInputs[FIELD_ID.bostonMatter.dob].currentValue === '' && formInputs[FIELD_ID.bostonMatter.ssn].currentValue === '') {
            validationMessage = `${formInputs[FIELD_ID.bostonMatter.dob].field.name} or ${formInputs[FIELD_ID.bostonMatter.ssn].field.name} must be specified in order to attach a "${fieldInput.field.name}."`
          }
        }
        break
      case FIELD_ID.bostonMatter.popSui:
        if (!fieldInput.currentValue.id) {
          if (formInputs[FIELD_ID.bostonMatter.implantProduct].currentValue && formInputs[FIELD_ID.bostonMatter.implantProduct].currentValue.length > 0) {
            validationMessage = `"${fieldInput.field.name}" cannot be blank if "${formInputs[FIELD_ID.bostonMatter.implantProduct].field.name}" is specified.`
          } else if (formInputs[FIELD_ID.bostonMatter.tkDeterm].currentValue.id) {
            validationMessage = `"${fieldInput.field.name}" cannot be blank if "${formInputs[FIELD_ID.bostonMatter.tkDeterm].field.name}" is specified.`
          }
        }
        break
      case FIELD_ID.bostonMatter.dismissalType:
        if (!fieldInput.currentValue.id) {
          if (formInputs[FIELD_ID.bostonMatter.dateDismissed].currentValue) {
            validationMessage = `"${fieldInput.field.name}" cannot be blank if a "${formInputs[FIELD_ID.bostonMatter.dateDismissed].field.name}" is specified.`
          }
        }
        break
      case FIELD_ID.bostonMatter.dateDismissed:
        if (!fieldInput.currentValue) {
          if (formInputs[FIELD_ID.bostonMatter.dismissalType].currentValue.id) {
            validationMessage = `"${fieldInput.field.name}" cannot be blank if a "${formInputs[FIELD_ID.bostonMatter.dismissalType].field.name}" is specified.`
          }
        }
        break
      case FIELD_ID.bostonMatter.relatedPlaintiff:
        if (fieldInput.currentValue.id && makeInteger(formInputs.action.type.id) === ACTION_TYPE.modify) {
          validationMessage = `Modification of duplicate records is prohibited. Please modify the master record specified in the "${fieldInput.field.name}" field.`
        }
        break
      default:
        console.log(`bossci.validation_hook "${fieldInput.field.validationHook}" not handled for field "${fieldInput.field.name}".`)
        validationMessage = ''
    }
    console.log('validationMessage: ', validationMessage)
    return validationMessage
  },

  case_selection: function case_selection(objectId, field, selectFieldCallback, setLargeChoice) {
    console.log('bossci.case_selection')
    return (
      <CaseSelection objectId={objectId} field={field} callback={selectFieldCallback} setSelectLargeChoice={setLargeChoice}/>
    )
  },

  behavior_hook: async function behavior_hook(object, field, action) {
    console.log('bossci.behavior_hook: ', object, field, action)
    const allInputs = window.rootFormInputs

    const readOnly = {
      id: BEHAVIOR_TYPE.readOnly,
      name: 'Read Only'
    }
    const optional = {
      id: BEHAVIOR_TYPE.optional,
      name: 'Optional'
    }

    let behaviorType = readOnly

    if (makeInteger(field.id) === FIELD_ID.bostonMatter.settlementGroup) {
      try {
        const results = await window.apolloClient.query({ query: HAS_PRIVILEGE, variables: { privilegeId: PRIVILEGE.editSettlementGroup } })
        console.log(results)
        if (results.data) {
          console.log(`User has 'Edit Settlement Group' privilege: ${results.data.hasPrivilege}`)
          if (results.data.hasPrivilege) {
            behaviorType = optional
          }
        }
      } catch (err) {
        console.log(JSON.stringify(err))
      }
    } else if (makeInteger(field.id) === FIELD_ID.caseCourt.mdlDocketNumber) {
      if (makeInteger(action.type.id) !== ACTION_TYPE.submit) {
        try {
          const results = await window.apolloClient.query({ query: MDL_DOCKET_VERIFIED, variables: { caseCourtId: object.id } })
          if (results.data) {
            console.log(`MDL Docket Number Verified: ${results.data.mdlDocketVerified}`)
            if (!results.data.mdlDocketVerified) {
              behaviorType = optional
            }
          }
        } catch (err) {
          console.log(JSON.stringify(err))
        }
      }
    } else if (makeInteger(field.id) === FIELD_ID.bostonMatter.matrixType) {
      console.log(allInputs, window)
      const value = makeInteger(allInputs[FIELD_ID.bostonMatter.matrixType].currentValue.id)
      console.log('Matrix Type value: ', value)
      if (action && makeInteger(action.type.id) === ACTION_TYPE.modify && value === matrixTypeJuly2021) {
        behaviorType = readOnly
      } else {
        behaviorType = optional
      }
    } else if (makeInteger(field.id) === FIELD_ID.bostonMatter.matrixTypeReason) {
      const value = makeInteger(allInputs[FIELD_ID.bostonMatter.matrixType].currentValue.id)
      console.log('Matrix Type value: ', value)
      if (action && makeInteger(action.type.id) === ACTION_TYPE.modify && value === matrixTypeJuly2021) {
        behaviorType = readOnly
      } else {
        behaviorType = optional
      }
    } else {
      try {
        const results = await window.apolloClient.query({ query: HAS_PRIVILEGE, variables: { privilegeId: PRIVILEGE.systemAdministrator } })
        if (results.data) {
          console.log(`User has 'System Administrator' privilege: ${results.data.hasPrivilege}`)
          if (results.data.hasPrivilege) {
            behaviorType = optional
          }
        }
      } catch (err) {
        console.log(JSON.stringify(err))
      }
    }
  
    console.log('bossci.behavior_hook: ', behaviorType)
    return behaviorType
  }
  
}

export default bossci
